import {
  ArcElement,
  BarElement,
  BarController,
  CategoryScale,
  Chart as ChartJS,
  Decimation,
  DoughnutController,
  Filler,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
  type ChartData,
  type ChartOptions,
  type ChartType
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(
  LineController,
  BarController,
  DoughnutController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  Filler,
  Decimation
);

type SmartChartProps<TType extends ChartType> = {
  type: TType;
  data: ChartData<TType>;
  options?: ChartOptions<TType>;
};

export function SmartChart<TType extends ChartType>({ type, data, options }: SmartChartProps<TType>) {
  const pointCount = data.datasets.reduce((sum, dataset) => {
    const values = Array.isArray(dataset.data) ? dataset.data.length : 0;
    return sum + values;
  }, 0);
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    ...options,
    plugins: {
      ...(options?.plugins ?? {}),
      decimation: {
        enabled: pointCount > 1000,
        algorithm: "lttb",
        samples: 1000,
        ...(options?.plugins?.decimation ?? {})
      }
    }
  } as ChartOptions<TType>;

  return <Chart type={type} data={data} options={chartOptions} />;
}
